<template>
  <div>
    <div class="bulletins-button" @click="toggleBulletins">
      <i class="fa fa-bell"></i>
      <span class="badge" v-if="newBulletins">{{ newBulletins }}</span>
    </div>
    <div class="bulletinsOutside" v-if="open" @click="toggleBulletins"></div>
    <div class="bulletins" :class="{ open: open }" tabindex="0">
      <div class="header">
        <div class="left">
          <h4 v-if="settings">Notification Settings</h4>
          <h4 v-else>{{ archives ? "Archived" : "" }} Notifications</h4>
          <div v-if="!settings && archives">( <span @click="getBulletins">Back</span> )</div>
          <div v-if="settings">( <span @click="toggleSettings">Back</span> )</div>
        </div>
        <div class="headerDropdown" v-show="headerDropdown && !settings">
          <div @click="markAllAsActedOn">Mark all as read</div>
          <div v-if="!archives" @click="markAllAsArchived">Archive all</div>
          <div v-if="!archives" @click="getArchivedBulletins">
            Show archives
          </div>
          <div v-else @click="getBulletins">Exit archives</div>
        </div>
        <div class="icons">
          <span class="fa-stack" v-if="!settings">
            <i class="fa fa-circle fa-stack-1x icon-background"></i>
            <i
              class="fa fa-ellipsis-v fa-stack-1x icon"
              @click="toggleHeaderDropdown"
            ></i>
          </span>
          <span class="fa-stack">
            <i class="fa fa-circle fa-stack-1x icon-background"></i>
            <i class="fa fa-gear fa-stack-1x icon" @click="toggleSettings"></i>
          </span>
          <span class="fa-stack">
            <i class="fa fa-circle fa-stack-1x icon-background"></i>
            <i
              class="fa fa-times fa-stack-1x icon"
              @click="toggleBulletins"
            ></i>
          </span>
        </div>
      </div>

      <bulletin-settings v-if="settings"></bulletin-settings>
      <ul class="content" v-else>
        <li v-for="(bulletin, $index) in uniqueBulletins" :key="bulletin.id">
          <a
            @click.prevent="toggleActedOn(bulletin.id, $index, true), open = !bulletin.link, goto(bulletin.link)"
            :href="bulletin.link ? baseUrl + bulletin.link: ''"
            class="bulletin" :class="{ noclick: !bulletin.link}"
          >
            <div class="image">
              <img class="avatar" :src="bulletin.avatar" />
              <img class="icon" :src="bulletin.icon" />
            </div>

            <div class="text" :class="{ unclicked: !bulletin.actedOn }">
              {{ bulletin.text }}

              <div class="meta">
                {{ bulletin.createdAt | timeago }}
                <span class="fa-stack">
                  <i class="fa fa-circle fa-stack-1x icon-background"></i>
                  <i
                    class="fa fa-ellipsis-h fa-stack-1x icon"
                    @click.stop.prevent="toggleBulletinDropdown(bulletin.id)"
                  ></i>
                </span>
                <div
                  class="bulletinDropdown"
                  v-show="openBulletin == bulletin.id"
                  @focusout="bulletinDropdownOutsideClick"
                  tabindex="1"
                  :ref="'bd' + bulletin.id"
                >
                  <div
                    @click.stop.prevent="
                      toggleActedOn(bulletin.id, $index, !bulletin.actedOn)
                    "
                  >
                    Mark as {{ bulletin.actedOn ? "unread" : "read" }}
                  </div>
                  <div
                    @click.stop.prevent="toggleArchived(bulletin.id, $index)"
                  >
                    {{ bulletin.archived ? "Unarchive" : "Archive" }}
                  </div>
                </div>
              </div>
            </div>

            <div>
              <i
                class="fa fa-circle"
                :class="{ unread: !bulletin.actedOn }"
              ></i>
            </div>
          </a>
        </li>

        <li v-if="areMore" class="load-more" @click="loadMore">Load More</li>
      </ul>
    </div>
  </div>
</template>
<script>
import bulletins from "../../services/bulletins";
import BulletinSettings from "./BulletinSettings";

import { uniqBy } from 'lodash';

export default {
  data() {
    return {
      open: false,
      settings: false,
      bulletins: [],
      newBulletins: 0,
      page: 0,
      areMore: false,
      headerDropdown: false,
      openBulletin: -1,
      archives: false,
      baseUrl: window.baseUrl + "/#/",
    };
  },
  components: {
    BulletinSettings,
  },
  sockets: {
    bulletinReceived(message) {
      this.bulletins.unshift(message);
      if (this.open !== true) {
        this.newBulletins++;
      }
      else {
        bulletins.markAllAsRead([message.id]);
      }
    },
  },
  mounted() {
    this.getBulletins();
  },
  methods: {
    loadMore() {
      this.page = this.page + 1;
      if (this.archives) this.getArchivedBulletins();
      else this.getBulletins();
    },
    toggleActedOn(id, index, val) {
      this.openBulletin = -1;
      this.bulletins[index].actedOn = val;
      bulletins.setActedOn(id, this.bulletins[index].actedOn);
    },
    goto(link){
      if (link)
        this.$router.push({ path: '/' +link });
    },
    markAllAsActedOn() {
      const bulletinIds = this.bulletins.map((b) => {
        return b.id;
      });
      this.bulletins.forEach((b) => {
        b.actedOn = true;
      });
      bulletins.markAllAsActedOn(bulletinIds);
    },
    markAllAsArchived() {
      const bulletinIds = this.bulletins.map((b) => {
        return b.id;
      });
      this.bulletins.forEach((b) => {
        b.actedOn = true;
      });
      bulletins.markAllAsArchived(bulletinIds);
      this.bulletins = [];
      this.headerDropdown = false;
    },
    toggleArchived(id, index) {
      this.bulletins[index].archived = !this.bulletins[index].archived;
      bulletins.setArchived(id, this.bulletins[index].archived);
      this.bulletins.splice(index, 1);
    },
    toggleBulletins() {
      this.openBulletin = -1;
      this.headerDropdown = false;
      if (!this.open) {
        this.settings = false;
        this.archives = false;
      }
      this.open = !this.open;
      if (this.open) {
        const bulletinIds = this.bulletins.map((b) => {
          return b.id;
        });
        bulletins.markAllAsRead(bulletinIds);
        let newLength = this.newBulletins - bulletinIds.length;
        if (newLength < 0) newLength = 0;
        this.newBulletins = newLength;
      }
    },
    toggleSettings() {
      this.openBulletin = -1;
      this.settings = !this.settings;
      if (!this.settings) this.dropdown = false;
    },
    toggleHeaderDropdown() {
      this.headerDropdown = !this.headerDropdown;
      this.openBulletin = -1;
    },
    toggleBulletinDropdown(id) {
      if (this.openBulletin == id) this.openBulletin = -1;
      else {
        this.openBulletin = id;
      }

      this.headerDropdown = false;
    },
    bulletinDropdownOutsideClick() {
      this.openBulletin = -1;
    },
    getBulletins() {
      if (this.archives) {
        this.page = 0;
        this.areMore = false;
      }
      bulletins.get(this.page).then((response) => {
        if (this.archives) this.bulletins = response.bulletins;
        else this.bulletins = this.bulletins.concat(response.bulletins);
        this.newBulletins = response.unread;
        bulletins.get(this.page + 1).then((response) => {
          this.archives = false;
          this.areMore = response.bulletins.length > 0;
        });
      });

      this.headerDropdown = false;
    },
    getArchivedBulletins() {
      if (!this.archives) {
        this.page = 0;
        this.areMore = false;
      }
      bulletins.getArchived(this.page).then((response) => {
        if (!this.archives) this.bulletins = response.bulletins;
        else this.bulletins = this.bulletins.concat(response.bulletins);
        this.newBulletins = response.unread;

        bulletins.getArchived(this.page + 1).then((response) => {
          this.archives = true;
          this.areMore = response.bulletins.length > 0;
        });
      });

      this.headerDropdown = false;
    },
  },
  computed: {
    uniqueBulletins() {
      return uniqBy(this.bulletins, (bulletin) => {
        return bulletin.id
      });
    }
  },
};
</script>

<style lang="scss">
.bulletins-button, .search-button {
  cursor: pointer;
  z-index: 9999;
  // position: fixed;
  // top: 2rem;
  // right: 2rem;

  i {
    // font-size: 2.5rem;
    position: relative;
    margin-left: 20px;
    margin-right: 8px;
    margin-bottom: 3px;
  }

  .badge {
    position: absolute;
    top: 15px;
    right: 63px;
    background-color: #ff4a4a;
    font-size: 10px;
    padding: 3px 5px;
  }
}
.bulletinsOutside {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: transparent;
  z-index: 9997;
  top: 0;
  right: 0;
}

.bulletins {
  position: fixed;
  width: 0;
  top: 0;
  right: 0;
  z-index: 9999997;
  height: 100vh;
  transition: all 0.25s;
  background: #222;

  &.open {
    width: 400px;
    box-shadow: -13px 4px 10px rgba(0, 0, 0, 0.5);
  }

  .header {
    display: flex;
    justify-content: space-between;
    border-bottom: rgba(255, 255, 255, 0.8) solid 1px;
    margin: 1.5rem;

    .left {
      display: flex;
      align-items: center;

      h4 {
        font-weight: 300;
        font-size: 20px;
      }

      div {
        margin-left: 1rem;
      }

      span {
        color: #33ccff;
        cursor: pointer;
      }
    }

    .icons {
      display: flex;
      align-items: center;
      font-size: 20px;
      cursor: pointer;

      .fa-stack {
        width: 3rem;

        .icon-background {
          color: transparent; //#3a3a3a;
          font-size: 3rem;
        }

        &:hover {
          .icon-background {
            color: #d3d3d34b;
          }

          .icon {
            color: white;
          }
        }
      }
    }

    .headerDropdown {
      position: absolute;
      top: 50px;
      right: 90px;
      background: #222222;
      color: lightgray;
      border: #444444 solid 1px;
      padding: 1rem;
      z-index: 9999998;
      // border-radius: 10px;

      div {
        background: transparent;
        cursor: pointer;
        // border-radius: 5px;
        padding: 1rem;

        &:hover {
          color: white;
          background: #d3d3d34b;
        }
      }
    }
  }

  .content {
    margin: 1.5rem;
    height: calc(100vh - 72px);
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .bulletin {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem;
      border-radius: 5px;
      font-weight: 500;
      text-decoration: none;
      color: inherit;

      &.noclick {
          cursor: default;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.08);
        color: white;
        .text {
          .meta {
            .fa-stack {
              color: lightgray;
              display: inline-block;
            }
          }
        }
      }
      .image {
        position: relative;

        .avatar {
          max-width: 56px;
          width: 56px;
          height: 56px;
          object-fit: cover;
          border-radius: 50%;
        }

        .icon {
          position: absolute;
          width: 20px;
          height: 20px;
          object-fit: contain;
          bottom: 0;
          right: 0;
        }
      }

      .text {
        margin-left: 1rem;
        margin-right: auto;

        &.unclicked {
          font-weight: 600;
        }

        .meta {
          display: flex;
          font-size: 12px;

          .fa-stack {
            color: transparent;
            width: 3rem;
            top: -3px;
            cursor: pointer;

            .icon-background {
              color: transparent;
              font-size: 3rem;
            }

            .icon {
              top: 1px;
              font-size: 16px;
            }

            &:hover {
              .icon-background {
                color: #d3d3d34b;
              }

              .icon {
                color: white;
              }
            }
          }
        }
      }

      .bulletinDropdown {
        position: relative;
        top: -37px;
        margin-bottom: -72px;
        background: #222222;
        color: lightgray;
        border: #444444 solid 1px;
        padding: 1rem;
        z-index: 9999999;
        // border-radius: 10px;
        font-weight: 600;

        div {
          background: transparent;
          cursor: pointer;
          // border-radius: 5px;
          padding: 1rem;

          &:hover {
            color: white;
            background: #d3d3d34b;
          }
        }
      }

      .fa-circle {
        font-size: 8px;
        color: transparent;

        &.unread {
          color: #3cf;
        }
      }
    }
  }

  .load-more {
    text-align: center;
    margin-top: 1.5rem;
    margin-bottom: 5rem;
    padding: 1rem 0;
    cursor: pointer;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    &:hover {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Bulletins.vue?6e30ca8d